module.exports = __webpack_public_path__ + "static/media/crane_homepage.5b4a2b55.png";